export default __webpack_public_path__ + "static/media/whiteBack1.d6953864.png";